import * as yup from 'yup'
import {
  CredentialField,
  getOptionalCredentials,
  getRequiredCredentials,
} from './supplierCredentialConfig'

const requiredValidators: Record<CredentialField, yup.StringSchema> = {
  endpoint: yup.string().trim().url('Must be a valid URL').required('Required'),
  apiKey: yup.string().trim().required('Required'),
  appKey: yup.string().trim().required('Required'),
  appSecret: yup.string().trim().required('Required'),
  accountNumber: yup.string().trim().required('Required'),
  unmanagedAccountNumber: yup.string().trim().required('Required'),
  dispatchReference: yup.string().trim().required('Required'),
}

const optionalValidators: Record<CredentialField, yup.StringSchema> = {
  endpoint: yup.string().trim().url('Must be a valid URL'),
  apiKey: yup.string().trim(),
  appKey: yup.string().trim(),
  appSecret: yup.string().trim(),
  accountNumber: yup.string().trim(),
  unmanagedAccountNumber: yup.string().trim(),
  dispatchReference: yup.string().trim(),
}

export default yup.lazy((values: any) => {
  const supplierGroupId = Number(values?.supplierGroupId)
  const valid = Number.isFinite(supplierGroupId)

  const required = valid ? getRequiredCredentials(supplierGroupId) : []
  const optional = valid ? getOptionalCredentials(supplierGroupId) : []

  const shape: Record<string, yup.AnySchema> = {
    supplierGroupId: yup.number().typeError('Required').required('Required'),
  }
  for (const field of required) {
    shape[field] = requiredValidators[field]
  }
  for (const field of optional) {
    if (!shape[field]) shape[field] = optionalValidators[field]
  }

  return yup.object().shape(shape)
})
